import { types } from 'mobx-state-tree';
import { Address, Contact } from '../definitions/common';


const NationalBankAuthorizedUser = types
    .model('NationalBankAuthorizedUser', {
        isSameAddress: types.maybe(types.boolean),
        address: types.maybe(Address),
    });

export default types.compose('NationalBankAuthorizedUser', Contact, NationalBankAuthorizedUser);
